// src/adminConfig.js
//
// Frontend allowlist of admin emails. This is ONLY used to hide/show UI
// (the "Admin" sidebar link and the /admin page). The real authorization
// gate lives in functions/index.js — adminListUsers and impersonateUser
// both call assertCallerIsRealAdmin which checks the same list on the
// server. Adding/removing admins requires editing BOTH places and
// redeploying functions.

export const ADMIN_EMAILS = new Set(
  [
    // TODO: keep in sync with ADMIN_EMAILS in functions/index.js
    'karapet.gyumjibashyan@gmail.com',
  ].map((e) => e.toLowerCase())
);

export const isAdminEmail = (email) =>
  !!email && ADMIN_EMAILS.has(String(email).toLowerCase());
